module.exports = "/_next/static/images/de9ea19a113f2bd02090058c74dc63bf-LogoAmazon.jpg.webp";